import { FormikProps } from 'formik';

export interface IField {
  name: string;
  value: string;
  onChange: (event: any) => void;
  onBlur: (event: any) => void;
}

const getError = (form: FormikProps<any>, field: IField) => {
  if (form && form.errors) {
    return form.errors[field.name] as string;
  }
  return '';
};

const getTouched = (form: FormikProps<any>, field: IField) => {
  return !!(form && form.touched && form.touched[field.name]);
};

export function getErrorAndTouched(form: FormikProps<any>, field: IField) {
  return {
    error: getError(form, field),
    touched: getTouched(form, field)
  };
}



// WEBPACK FOOTER //
// ./src/common/formik/utils.tsx